import { i18n } from '@/shared/i18n'

const { t } = i18n.global

export const statusOptions = [
  { caption: t('common.active'), value: 'active' },
  { caption: t('common.inactive'), value: 'inactive' },
]

export const languageOptions = [
  { caption: t('language.ru'), value: 'ru' },
  { caption: t('language.uz'), value: 'uz' },
]

export enum userType {
  SUPER = 'super',
  USER = 'user',
}

export const discountAmount = 'Discount for order amount'
export const discountQuantity = 'Addition to quantity'

export const promotionTypeOptions = [
  { caption: t('forms.discountQuantity'), value: discountQuantity },
  { caption: t('forms.discountAmount'), value: discountAmount },
]

export const orderOptions = [
  { caption: t('forms.cash'), value: true },
  { caption: t('forms.transfer'), value: false },
]

export const orderStatus = [
  { caption: t('forms.orderStatusDraft'), value: 'draft' },
  { caption: t('forms.orderStatusTest'), value: 'test' },
]

export enum orderReturnType {
  FULL = 'Full return',
  CUSTOM = 'Custom return',
  PARTIAL = 'Partial return',
}

export const orderReturnTypeOptions = [
  { caption: t('forms.returnTypeFull'), value: orderReturnType.FULL },
  { caption: t('forms.returnTypeCustom'), value: orderReturnType.CUSTOM },
  { caption: t('forms.returnTypePartial'), value: orderReturnType.PARTIAL },
]

export const returnTypeLabels: Record<string, string> = {
  [orderReturnType.FULL]: t('forms.returnTypeFull'),
  [orderReturnType.PARTIAL]: t('forms.returnTypePartial'),
  [orderReturnType.CUSTOM]: t('forms.returnTypeCustom'),
}
